import { $ } from 'hanako-ts/dist-legacy/Framework';
export class BackgroundAnimation {
    constructor(element) {
        this.lastFrameTime = 0;
        this.slidingElements = [];
        this.isPaused = false;
        this.orientation = 'landscape';
        this.pixelRatio = window.devicePixelRatio || 1;
        this.requestAnimationFrame = () => {
            this.draw();
            requestAnimationFrame(this.requestAnimationFrame);
        };
        this.element = element;
        this.context = this.element.get(0).getContext('2d', {
            alpha: false
        });
        $(window).on('resize', () => {
            this.resize();
        }).on('blur', () => {
            this.isPaused = true;
        }).on('focus', () => {
            this.isPaused = false;
        });
        this.setup();
        this.resize();
        requestAnimationFrame(this.requestAnimationFrame);
    }
    resize() {
        this.orientation = $(window).width() > $(window).height() ? 'landscape' : 'portrait';
        this.bufferDimensions = {
            width: this.element.width() * this.pixelRatio,
            height: this.element.height() * this.pixelRatio
        };
        this.element.attr('width', this.bufferDimensions.width);
        this.element.attr('height', this.bufferDimensions.height);
        this.element.css({
            width: this.bufferDimensions.width / this.pixelRatio,
            height: this.bufferDimensions.height / this.pixelRatio
        });
        this.computeWidthReference();
    }
    setup() {
        $('.sliding-element').each((slidingElement) => {
            const image = new Image();
            image.src = slidingElement.data('src');
            let element = {
                image: image,
                ratio: 0,
                size: 0,
                position: 0,
                speed: parseFloat(slidingElement.data('speed')),
                repeat: slidingElement.data('repeat') === 'true',
                orientation: slidingElement.data('orientation'),
                isReference: slidingElement.data('reference') === 'true'
            };
            this.slidingElements.push(element);
            image.onload = () => {
                element.ratio = element.image.width / element.image.height;
                this.computeWidthReference();
            };
        });
    }
    draw() {
        // Limit frame rate
        const time = Date.now();
        if (this.isPaused || time - this.lastFrameTime < 1000 / 60)
            return;
        this.lastFrameTime = time;
        // fill background with purple
        this.context.fillStyle = '#5637ff';
        this.context.fillRect(0, 0, this.bufferDimensions.width, this.bufferDimensions.height);
        this.slidingElements.forEach((element) => {
            if (element.ratio == 0 || element.orientation != this.orientation)
                return;
            const direction = element.speed < 0 ? -1 : 1;
            const elementSize = this.orientation === 'landscape' ? this.bufferDimensions.height * element.ratio : this.bufferDimensions.width / element.ratio;
            const repeatCount = element.repeat
                ? this.orientation === 'landscape'
                    ? Math.ceil(this.bufferDimensions.width / (this.bufferDimensions.height * element.ratio))
                    : Math.ceil(this.bufferDimensions.height / (this.bufferDimensions.width * element.ratio)) + 1
                : 2;
            element.position += element.speed;
            if (direction < 0) {
                if (element.position < -elementSize)
                    element.position = 0;
            }
            else {
                if (element.position > elementSize)
                    element.position = 0;
            }
            for (let i = 0; i < repeatCount + 1; i++) {
                if (this.orientation === 'landscape') {
                    this.context.drawImage(element.image, (i * (elementSize - 1) * direction * -1) + element.position, 0, this.bufferDimensions.height * element.ratio, this.bufferDimensions.height);
                }
                else {
                    this.context.drawImage(element.image, 0, (i * (elementSize - 1) * direction * -1) + element.position, this.bufferDimensions.width, this.bufferDimensions.width / element.ratio);
                }
            }
        });
    }
    computeWidthReference() {
        this.slidingElements.forEach((element) => {
            if (!element.isReference)
                return;
            console.log(this.bufferDimensions.height, this.bufferDimensions.height * element.ratio / this.pixelRatio);
            $('#front-animation').css('--width-reference', (this.bufferDimensions.height * element.ratio / this.pixelRatio / 1.4545454545) + 'px');
        });
    }
}
